import { useEffect, useState } from "react";
import SideNavLayout from "../customsidenav/sidenavlayout";
import ListIcon from '@mui/icons-material/List';
import GridViewIcon from '@mui/icons-material/GridView';
import InventoryListView from "./listview";
import CardView from "./cardview";
import Addentrymodalview from "./addentry";
import { Backdrop, CircularProgress } from "@mui/material";
import api from "../api/api";
import { getPracticeId, practiceShortName } from "../config/practice";

const Inventory = () => {
  const [selectedView, setSelectedView] = useState("card");
const [addentrymodal,setAddEntryModal]=useState(false)
const practiseid = getPracticeId();
const [loading,setLoading]=useState(false)
const [inventoryData,setInventoryData]=useState([])
const fetchinventry=async(isload=false)=>{
  try {
    setLoading(true)
    const response =await api.get(`/v1/${practiseid}/inventory`)
      const contextRes = await api.get(
    `/v1/${practiseid}/inventory_lookup?context=item_type`
  );
    if(response.status===200){
        const contextMap = (contextRes?.data || []).reduce((acc, cur) => {
    acc[cur.id] = cur.name;
    return acc;
  }, {});
  const enrichedInventory = (response.data || []).map(item => ({
      ...item,
      context_name: contextMap[item.item_type] || "-"   // ✅ fallback
    }));

    setInventoryData(enrichedInventory);
    }else{
   setInventoryData([])
    }
  } catch (error) {
    console.log(error)
  }finally{
setLoading(false)
  }
}
useEffect(()=>{
document.title = `${practiceShortName()} - Inventory Management`;
fetchinventry()
},[])

  return (
    <SideNavLayout>
      <div className="p-4">
        {/* View Toggle Row - Wrapper */}
        <div className="flex w-fit rounded-[12.75px] bg-[#DBEAFE] p-1">
          {/* Card View */}
          <div
            onClick={() => setSelectedView("card")}
            className={`flex items-center gap-1 cursor-pointer text-xs px-3 py-1 rounded-[12.75px] transition ${
              selectedView === "card" ? "bg-white" : "bg-transparent"
            }`}
          >
            <GridViewIcon style={{ fontSize: 16, color: '#0A0A0A' }} />
            <span className="text-[#0A0A0A] font-semibold">Card View</span>
          </div>

          {/* List View */}
          <div
            onClick={() => setSelectedView("list")}
            className={`flex items-center gap-1 cursor-pointer text-xs px-3 py-1 rounded-[12.75px] transition ${
              selectedView === "list" ? "bg-white" : "bg-transparent"
            }`}
          >
            <ListIcon style={{ fontSize: 16, color: '#0A0A0A' }} />
            <span className="text-[#0A0A0A] font-semibold">List View</span>
          </div>
        </div>
        <div>
{selectedView=='card'?<><CardView  fetchinventry={fetchinventry} setLoading={setLoading} data={inventoryData} setAddEntryModal={setAddEntryModal}/></>:<>
<InventoryListView  fetchinventry={fetchinventry} setLoading={setLoading} data={inventoryData} setAddEntryModal={setAddEntryModal}/></>}

        </div>
       {addentrymodal?<Addentrymodalview fetchinventry={fetchinventry} setLoading={setLoading} setAddEntryModal={setAddEntryModal}/>:<></>}
      </div>
           <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
     <CircularProgress color="inherit" />
   </Backdrop>
    </SideNavLayout>
  );
};

export default Inventory;
